document.querySelector('[submit-loan-button]')?.addEventListener('click', async event => {
    event.preventDefault();

    const target = event.target as HTMLFormElement
    const targetForm = target.closest('form')
    const spinner = document.getElementById('loading-spinner')

    if (targetForm) {
        spinner?.classList.remove('hidden')

        const formData = new FormData(targetForm);
        const errorDiv = document.querySelector('.error-text')

        let response = await fetch('?', { method: 'POST', body: formData })
        let data = await response.json()
        console.log(data)

        if (data.success) {
            window.location.href = `/loan/credit-app-success?CreditAppDealJacketId=${data.creditAppDealJacketId}`
        }
        else {
            spinner?.classList.add('hidden')

            if (errorDiv)
                errorDiv.innerHTML = "An error occurred: " + data.error
            else
                alert("An error occurred: " + data.error)

            // Scroll to top
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
})
